import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '../hooks/useTheme';
import { Colors, Radius } from '../theme/tokens';

interface ProgressBarProps {
  /** 0–1 */
  progress: number;
  color?: string;
  height?: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  color,
  height = 4,
}) => {
  const { colors, isDark } = useTheme();
  const pct  = Math.min(Math.max(progress, 0), 1) * 100;
  const fill = color ?? colors.brand;
  const track = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.07)';

  return (
    <View style={[styles.track, { backgroundColor: track, height }]}>
      <View style={[styles.fill, { width: `${pct}%`, backgroundColor: fill, height }]} />
    </View>
  );
};

const styles = StyleSheet.create({
  track: {
    width:        '100%',
    borderRadius: Radius.full,
    overflow:     'hidden',
  },
  fill: {
    borderRadius: Radius.full,
  },
});
